import { actionReportsApi } from "./ActionReportAPI";
import type {
  GetWatchlistArgs,
  RemoveWatchlistItemArgs,
  UpdateWatchlistArgs,
  WatchlistResponse,
} from "./ActionReportAPI.types";

export const watchlistBffApi = actionReportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getWatchlist: builder.query<WatchlistResponse, GetWatchlistArgs>({
      query: ({ ownerAff, ownerAbo, period }) => {
        const queryParams = new URLSearchParams({
          Aff: ownerAff,
          Abo: ownerAbo,
        });

        if (period) {
          queryParams.append("Period", period);
        }

        return `/acc-action-report-v2-api/api/watchlist?${queryParams}`;
      },
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
    updateWatchlist: builder.mutation<void, UpdateWatchlistArgs>({
      query: ({ ownerAff, ownerAbo, watchList }) => {
        const queryParams = new URLSearchParams({
          Aff: ownerAff,
          Abo: ownerAbo,
        });

        return {
          url: `/acc-action-report-v2-api/api/watchlist?${queryParams}`,
          method: "POST",
          body: { WatchList: watchList },
        };
      },
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
    removeWatchlistItem: builder.mutation<void, RemoveWatchlistItemArgs>({
      query: ({ ownerAff, ownerAbo, targetAff, targetAbo, watchList }) => {
        const queryParams = new URLSearchParams({
          Aff: ownerAff,
          Abo: ownerAbo,
          TargetAff: targetAff,
          TargetAbo: targetAbo,
        });

        return {
          url: `/acc-action-report-v2-api/api/watchlist/remove-item?${queryParams}`,
          method: "POST",
          body: { WatchList: watchList },
        };
      },
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetWatchlistQuery,
  useLazyGetWatchlistQuery,
  useUpdateWatchlistMutation,
  useRemoveWatchlistItemMutation,
} = watchlistBffApi;
